import { log } from "../../../engine/logger/logger";
import { openModal } from "../../../ui/containers/Modal";
import { ButtonComp } from "../../../ui/input/Button";
import { ComponentF, createElement } from "../../../ui/ui";
import { createAction } from "../../actions/Action";
import { interact, stanceChange } from "../../actions/ActionItems";
import {
  gameData,
  getItemsForPosition,
  runPlayerAction,
} from "../../GameManager";
import { WearableModal } from "../info/WearableModal";
import { WieldableModal } from "../info/WieldableModal";
import { DropModal } from "./DropModal";
import { PickupModal } from "./PickupModal";
import { UseModal } from "./UseModal";

export const InventoryControls: ComponentF<void> = (C) => {
  return [
    createElement(
      ButtonComp,
      { x: 0, y: 0, w: C.bounds.w, h: 1 },
      {
        title: "Use Item",
        keys: "u",
        showKey: true,
        onClick: () => {
          if (!gameData.actionPending) {
            openModal(createElement(UseModal, { x: 0, y: 0, w: 60, h: 32 }));
          }
          return;
        },
      }
    ),
    createElement(
      ButtonComp,
      { x: 0, y: 1, w: C.bounds.w, h: 1 },
      {
        title: "Pickup Item",
        keys: "p",
        showKey: true,
        onClick: () => {
          if (!gameData.actionPending) {
            if (16 < gameData.player.contains.size) {
              log("Cannot pick up items, inventory full");
              return;
            }
            const items = getItemsForPosition(
              gameData.player.x,
              gameData.player.y
            );
            if (items.find((i) => !i.breed.furniture)) {
              openModal(
                createElement(PickupModal, { x: 0, y: 0, w: 60, h: 32 })
              );
            } else {
              log("Nothing here to pick up.");
            }
          }
        },
      }
    ),
    createElement(
      ButtonComp,
      { x: 0, y: 2, w: C.bounds.w, h: 1 },
      {
        title: "Equip Weapon",
        keys: "r",
        showKey: true,
        onClick: () => {
          if (!gameData.actionPending) {
            openModal(
              createElement(WieldableModal, { x: 0, y: 0, w: 78, h: 46 })
            );
          }
          return;
        },
      }
    ),
    createElement(
      ButtonComp,
      { x: 0, y: 3, w: C.bounds.w, h: 1 },
      {
        title: "Wear Armor",
        keys: "q",
        showKey: true,
        onClick: () => {
          if (!gameData.actionPending) {
            openModal(
              createElement(WearableModal, { x: 0, y: 0, w: 48, h: 36 })
            );
          }
        },
      }
    ),
    createElement(
      ButtonComp,
      { x: 0, y: 4, w: C.bounds.w, h: 1 },
      {
        title: "Drop Item",
        keys: "o",
        showKey: true,
        onClick: () => {
          if (!gameData.actionPending) {
            if (gameData.player.contains.find((i) => !i.breed.mandatory)) {
              openModal(createElement(DropModal, { x: 0, y: 0, w: 60, h: 32 }));
            } else {
              log("Nothing to drop");
            }
          }
        },
      }
    ),
    createElement(
      ButtonComp,
      { x: 0, y: 5, w: C.bounds.w, h: 1 },
      {
        title: "Swap 1h/2h stance",
        keys: "t",
        showKey: true,
        onClick: () => {
          if (!gameData.actionPending) {
            runPlayerAction(createAction(stanceChange, gameData.player, null));
          }
        },
      }
    ),
    createElement(
      ButtonComp,
      { x: 0, y: 6, w: C.bounds.w, h: 1 },
      {
        title: "Interact",
        keys: "z",
        showKey: true,
        onClick: () => {
          if (!gameData.actionPending) {
            const items = getItemsForPosition(
              gameData.player.x,
              gameData.player.y
            ).filter((item) => item.breed.interact);
            if (items.length) {
              runPlayerAction(createAction(interact, gameData.player, null));
            } else {
              log("There is nothing to interact with here");
            }
          }
        },
      }
    ),
  ];
};
